import entities from './entities';
import ui from './ui';

export default {
  entities,
  ui,
};
